import React, { useEffect, useState } from "react";
import { Main, Content } from "../../../components/Layout";
import { ChartsBar } from "../../../components/Charts";
import { Col, Row } from "react-bootstrap";
import Slct from "../../../components/Slct";
import getCommercial from "../../../util/getCommercial";
import Loading from "../../../components/Loading";
import TableResponsive from "../../../components/TableResponsive";
import getCalendar from "../../../util/getCalendar";
import { formatDate } from "../../../util/functions";
import { ModalAddTask } from "../../../components/Modal";
import IcEditar from "../../../components/Svg/IcEditar";
import StatusFlag from "../../../components/StatusFlag";
import { PrintPage } from "../../../components/PrintPage";
import { formatReal } from "../../../util/functions";
import useWrapper from "../../../hooks/useWrapper";

export default function ReportsOperational() {
  const { setbreadcrumb, me } = useWrapper();

  const [reload, setreload] = useState();
  const [modalItem, setmodalItem] = useState();

  const [filter, setFilter] = useState({
    Turma: { value: null },
  });

  // Lists
  const [groups, setgroups] = useState();
  useEffect(() => {
    (async function () {
      if (!groups) {
        const _groups = await getCommercial(null, null, "", "", true);
        setgroups(_groups);
      }
    })();
  }, []);

  // Active
  const [group, setgroup] = useState();
  const [groupCalendar, setgroupCalendar] = useState([]);
  useEffect(() => {
    (async function () {
      if (filter["Turma"].value) {
        const _group = await getCommercial(filter["Turma"].value, null, "", "", true);
        setgroup(_group);
        const _group_calendar = await getCalendar(filter["Turma"].value);
        setgroupCalendar(_group_calendar);
      }
    })();
  }, [filter["Turma"], reload]);

  const [reports, setReports] = useState();
  useEffect(() => {
    if (filter["Organizar Por"] === "Por Fornecedor") {
      let _overview = {
        with_suplier: 0,
        without_suplier: 0,
      };
      _overview.with_suplier = group.packages_data.supliers
        .filter(__suplier => !!__suplier.id)
        .reduce((__accumulator, __suplier) => __accumulator + (__suplier.events.length || 0), 0);
      _overview.without_suplier = group.packages_data.supliers
        .filter(__suplier => !__suplier.id)
        .reduce((__accumulator, __suplier) => __accumulator + (__suplier.events.length || 0), 0);
      setReports({
        title: "Operacional por Fonecedor",
        data: [
          { label: "Com Fornecedor", value: _overview.with_suplier },
          { label: "Sem Fornecedor", value: _overview.without_suplier },
        ],
        table: group?.packages_data.supliers.map(__suplier => ({
          Fornecedor: __suplier.name || "A Definir",
          id: __suplier.id,
          Eventos: __suplier.events.map(__event => ({
            Evento: __event.name,
            id: __event.id,
            Recursos: __event.resources.map(__resource => ({
              Recurso: __resource.name,
              "Valor Unitário": `${formatReal(__resource.single_value)}`,
              Quantidade: __resource.qtd,
              "Valor Total": `${formatReal(__resource.qtd * __resource.single_value)}`,
            })),
          })),
        })),
      });
    } else if (filter["Organizar Por"] === "Por Solenidade") {
      let _overview = {
        with_suplier: 0,
        without_suplier: 0,
      };
      _overview.with_suplier = group.packages_data.supliers
        .filter(__suplier => !!__suplier.id)
        .reduce((__accumulator, __suplier) => __accumulator + (__suplier.events.length || 0), 0);
      _overview.without_suplier = group.packages_data.supliers
        .filter(__suplier => !__suplier.id)
        .reduce((__accumulator, __suplier) => __accumulator + (__suplier.events.length || 0), 0);

      setReports({
        title: "Operacional por Solenidade",
        data: [
          { label: "Com Fornecedor", value: _overview.with_suplier },
          { label: "Sem Fornecedor", value: _overview.without_suplier },
        ],
        table: group?.packages_data.events.map(__event => ({
          Evento: __event.name,
          id: __event.id,
          Recursos: __event.resources.map(__resource => ({
            Recurso: __resource.name,
            id: __resource.id,
            "Valor Unitário": `${formatReal(__resource.single_value)}`,
            Quantidade: __resource.qtd,
            "Valor Total": `${formatReal(__resource.qtd * __resource.single_value)}`,
            Fornecedor: __resource.provider_name || "A Definir",
          })),
        })),
      });
    } else if (filter["Organizar Por"] === "Pendências do Calendário") {
      setReports({
        title: "Operacional por Calendário",
        data: [
          {
            label: "Atrasadas",
            value: groupCalendar.filter(__task => __task.status === "Atrasada")?.length || 0,
            color: "var(--color-error)",
          },
          {
            label: "Confirmadas",
            value: groupCalendar.filter(__task => __task.status === "Confirmada")?.length || 0,
            color: "var(--color-success)",
          },
          {
            label: "Previstas",
            value: groupCalendar.filter(__task => __task.status === "Prevista")?.length || 0,
            color: "var(--color-ok)",
          },
          {
            label: "Pendentes",
            value: groupCalendar.filter(__task => __task.status === "Pendentes")?.length || 0,
            color: "var(--color-warning)",
          },
          {
            label: "Concluídas",
            value: groupCalendar.filter(__task => __task.status === "Concluída")?.length || 0,
            color: "var(--color-grey-2)",
          },
        ],
        table: groupCalendar.map(__task => ({
          Tarefa: __task.name,
          id: __task.id || null,
          Usuário: __task.user?.name || "-",
          Data: formatDate(__task.date_end, 2),
          Status: __task.status,
        })),
      });
    }
  }, [filter["Organizar Por"], group, groupCalendar]);

  useEffect(() => {
    setbreadcrumb([{ label: "Relatórios" }]);
  }, []);

  return (
    <PrintPage has_logo={true} signed_by={me.username}>
      <Main>
        <Content>
          <Row>
            <Col>
              <div className="d-flex justify-content-between">
                <h2 className="page-title">Relatórios do Operacional</h2>
                <div className="d-flex ml-4">
                  <PrintPage.PrintButton label="Gerar PDF" />
                  <PrintPage.CSVButton
                    label="Gerar CSV"
                    title={reports?.title}
                    overview={reports?.data}
                    table={reports?.table}
                    signed_by={me.username}
                    filter={filter}
                    has_subgroups={
                      filter["Organizar Por"] === "Por Solenidade" || filter["Organizar Por"] === "Por Fornecedor"
                    }
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mt-2" style={{ zIndex: 10, position: "relative" }}>
            <Col sm={3}>
              <span className="lince-input_label">Turma</span>
              {groups ? (
                <Slct
                  className="w-100"
                  placeholder="..."
                  value={filter["Turma"].value}
                  options={groups || []}
                  onChange={e => {
                    setFilter({
                      ...filter,
                      Turma: e,
                    });
                  }}
                />
              ) : (
                <Loading />
              )}
            </Col>
            {!!filter["Turma"].value && (
              <Col sm={3}>
                <span className="lince-input_label">Organizar por:</span>
                {group ? (
                  <Slct
                    className="w-100"
                    placeholder="..."
                    value={filter["Organizar Por"]}
                    options={[
                      { label: "Por Solenidade", value: "Por Solenidade" },
                      { label: "Por Fornecedor", value: "Por Fornecedor" },
                      { label: "Pendências do Calendário", value: "Pendências do Calendário" },
                    ]}
                    onChange={e => {
                      setFilter({
                        ...filter,
                        "Organizar Por": e.value,
                      });
                    }}
                  />
                ) : (
                  <Loading />
                )}
              </Col>
            )}
          </Row>
          {filter["Organizar Por"] === "Por Solenidade" && (
            <>
              <Row className="mb-4">
                <Col>
                  {group && (
                    <ChartsBar reports={reports?.data || []} title="Recursos por Solenidade" type="solenidades" />
                  )}
                </Col>
              </Row>
              <Row>
                <Col>
                  {reports?.table.map(__event => (
                    <div className="-container-group">
                      <h2 className="mini-title mb-2">{__event["Evento"]}</h2>
                      {__event["Recursos"]?.length > 0 ? (
                        <TableResponsive
                          table={{
                            head: [
                              { data: "Recurso" },
                              { data: "Valor Unitário" },
                              { data: "Quantidade" },
                              { data: "Valor Total" },
                              { data: "Fonecedor", table_width: "300px" },
                            ],
                            body: __event["Recursos"].map(__resource => ({
                              data: [
                                { element: <span>{__resource["Recurso"]}</span> },
                                { element: <span>{__resource["Valor Unitário"]}</span> },
                                { element: <span>{__resource["Quantidade"]}</span> },
                                { element: <span>{__resource["Valor Total"]}</span> },
                                {
                                  element: (
                                    <>
                                      {__resource["Fornecedor"] ? (
                                        <span>{__resource["Fornecedor"]}</span>
                                      ) : (
                                        <span className="-txt-error">A Definir</span>
                                      )}
                                    </>
                                  ),
                                },
                              ],
                            })),
                          }}
                        />
                      ) : (
                        <p className="pb-3">Esta Solenidade não possui recursos associados.</p>
                      )}
                    </div>
                  ))}
                </Col>
              </Row>
            </>
          )}
          {filter["Organizar Por"] === "Por Fornecedor" && (
            <>
              <Row className="mb-4">
                <Col>
                  {group && (
                    <ChartsBar reports={reports?.data || []} title="Recursos por Fornecedor" type="solenidades" />
                  )}
                </Col>
              </Row>
              <Row className="mb-4">
                <Col>
                  {reports?.table.map(__suplier => (
                    <div className="-container-group pb-2 pl-3 pr-3">
                      <h2 className="mini-title mb-3">
                        {__suplier["Fornecedor"] || <span className="-txt-error">A Definir</span>}
                      </h2>
                      {__suplier["Eventos"]?.map(__event => (
                        <div className="-container-group">
                          <h2 className="mini-title-2 mb-2">{__event["Evento"]}</h2>
                          {__event["Recursos"].length > 0 ? (
                            <TableResponsive
                              table={{
                                head: [
                                  { data: "Recurso", table_width: "300px" },
                                  { data: "Valor Unitário" },
                                  { data: "Quantidade" },
                                  { data: "Valor Total" },
                                ],
                                body: __event["Recursos"].map(__resource => ({
                                  data: [
                                    { element: <span>{__resource["Recurso"]}</span> },
                                    { element: <span>{__resource["Valor Unitário"]}</span> },
                                    { element: <span>{__resource["Quantidade"]}</span> },
                                    { element: <span>{__resource["Valor Total"]}</span> },
                                  ],
                                })),
                              }}
                            />
                          ) : (
                            <p className="pb-3">Esta Solenidade não possui recursos associados.</p>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
                </Col>
              </Row>
            </>
          )}
          {filter["Organizar Por"] === "Pendências do Calendário" && (
            <>
              <Row className="mb-4">
                <Col>
                  <ChartsBar reports={reports?.data || []} title="Pendências do Calendário" type="tarefas" />
                </Col>
              </Row>
              <Row>
                <Col>
                  <TableResponsive
                    table={{
                      head: [
                        { data: "Tarefa" },
                        { data: "Usuário" },
                        { data: "Data" },
                        { data: "Status" },
                        { data: "" },
                      ],
                      body:
                        reports?.table?.map(__task => ({
                          onClick: () => {
                            setmodalItem(__task.id);
                          },
                          data: [
                            { element: <span>{__task["Tarefa"]}</span> },
                            { element: <span>{__task["Usuário"]}</span> },
                            {
                              element: (
                                <span>
                                  {__task["Data"]}
                                  {/* <span className={tableStyle.subtext}>
                                  {__task.all_day ? "Dia Inteiro" : formatDate(__task.date_end, 6) || "-"}
                                </span> */}
                                </span>
                              ),
                            },
                            {
                              element: (
                                <span>
                                  <StatusFlag status={__task["Status"]} />
                                </span>
                              ),
                            },
                            {
                              element: (
                                <span style={{ float: "right", opacity: 0.5 }}>
                                  <IcEditar />
                                </span>
                              ),
                            },
                          ],
                        })) || [],
                    }}
                  />
                </Col>
              </Row>
            </>
          )}
        </Content>
      </Main>
      <ModalAddTask
        reload={reload}
        reloadCalendar={() => setreload(!reload)}
        itemId={modalItem}
        show={!!modalItem}
        onHide={() => setmodalItem(null)}
      />
    </PrintPage>
  );
}
